const imgData_2020 = {
  almost_invincible: {
    title: 'Almost Invincible',
    imgs: {
      full: {
        src: require('./almost_invincible_2020_web.jpg'),
        width: 707,
        height: 1000,
      },
      thumb: {
        src: require('./almost_invincible_2020_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink, graphite and watercolour pencil on mixed media paper. 297 x 420 mm ( 11.69 x 16.53 in), 2020.',
    price: 94,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/855625433/',
    printUrl: 'https://www.etsy.com/ie/listing/855629301/',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "We need a dragon. That western-type, fierce, all the years and battles visible on his scales. No, don't illustrate \"The Hobbit\" (you're not a fan of the story anyway, the dragon DIES :'( ), let's just place this guy in a composition, like a coat of arms. All right, not an illustration, but at least can I take that monstrous spear as an inspiration? Looks ok in a coat of arms, doesn't it? Let's make it two spears then. Fire and smoke. Let's add some of the latter, that always makes a nice background. This is still too relaxed. When you're this fierce and a badass, you can't just hang around in the air, can you? You can hang around in a swarm of arrows! Not that you care, you're invincible. Almost.<br /><br />That sums up my line of thoughts while creating my contribution to this year's #smaugust on Instagram. Despite my doubts I finished it eventually. And my thoughts in the end? Well it's better than I thought it would be, and I figured I actually like this monochromatic approach (also much quicker to work with only one colour on your palette).",
  },
  bonds: {
    title: 'Bonds',
    imgs: {
      full: {
        src: require('./bonds_2020_web.jpg'),
        width: 707,
        height: 1000,
      },
      thumb: {
        src: require('./bonds_2020_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and coloured pencil on mixed media paper. 297 x 420 mm (11.69 x 16.53 in), 2020.',
    price: 115,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/815319864/',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'mixed_media_painting',
    story:
      "How does fatigue bond the mind and prevent it from flying free? I was exhausted both mentally and physically when this drawing was born, as I had a long cycling exercise before. I didn't have a concept in mind, I only had the blank sheet and just drew. When pushed to the limits, this is what remains to my mind: my favourite flower, birds and dragons, tangled together.<br /><br />The artwork was created using traditional inking with sepia acrylic ink and a coloured pencil. This was the first time I tried this transparent ink on a separate piece and I like how it ended up giving this aged look to the image.",
  },
  mother_bear: {
    title: 'Mother Bear',
    imgs: {
      full: {
        src: require('./mother_bear_2020_web.jpg'),
        width: 1000,
        height: 703,
      },
      thumb: {
        src: require('./mother_bear_2020_thumb.jpg'),
        width: 600,
        height: 422,
      },
    },
    year: '2020',
    description:
      'Watercolour and pen on watercolour paper. 420 x 297 mm ( 11.69 x 16.53 in), 2020.',
    price: 120,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/813397798/',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "All the crows are leading the way to one spot in the forest. They are the messengers, eyes and ears of Mother Bear, dwelling deep in the woods. Mother Bear doesn't leave the forest, but she knows everything that is going on around the world... so she doesn't get surprised when you reach the clearing filled with mossy rocks to see her. You just had to follow the crows and here you are. But Mother Bear just smiles, she already knows you.<br /><br />The idea of Mother Bear came to me when I was browsing through my older reference photos. I had a shot of a bear looking so friendly, taken at the Lisbon zoo when I was on a holiday there. As I usually focus more on birds or dragons I just didn't have any good ideas for the picture, but one night I just sketched the bear as practice, when this whole scene just occurred to me, as if I'd known this since forever. I just had to discover her! And so it felt like Mother Bear already knew about me, and our encounter was a surprise only to me.",
  },
  entering_the_red_forest: {
    title: 'Entering the Red Forest',
    imgs: {
      full: {
        src: require('./entering_the_red_forest_2020_web.jpg'),
        width: 1000,
        height: 709,
      },
      thumb: {
        src: require('./entering_the_red_forest_2020_thumb.jpg'),
        width: 600,
        height: 425,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 420 x 297 mm ( 11.69 x 16.53 in), 2020.',
    price: 120,
    original: 'SOLD',
    prints: 'NOTYET',
    buyUrl: 'https://www.etsy.com/ie/listing/807843812/',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'Not all ancient forests have to be dark and damp... Here\'s the colourful Red Forest, but when you enter you\'ll face the same mystique as in the dark ones. And from the mist a long white body emerges, with a mane and antlers of crimson, holding a golden orb that casts a blurry yellow glow over its keeper. Here\'s the guardian spirit of the woods, and you may wonder, should you run?<br /><br />I never really felt as comfortable in forests as in big open plains. The trees are just towering over you, and it\'s silent and noisy at the same time. It\'s motionless and full of little movements. It\'s peaceful and threatening. This is the kind of duality I wanted to show in this painting. It\'s up to the viewer to decide if they want to run, or stay. Because the forest is both welcoming and hostile.<br /><br />Reference photo I used for the forest is <a href="https://unsplash.com/photos/CoD2Q92UaEg" title="Red Forest reference photo" target="_blank" rel="noopener noreferrer" >here</a>.',
  },
  the_old_blind_worm_of_the_swamp: {
    title: 'The Old Blind Worm of the Swamp',
    imgs: {
      full: {
        src: require('./the_old_blind_worm_of_the_swamp_2020_web.jpg'),
        width: 1000,
        height: 717,
      },
      thumb: {
        src: require('./the_old_blind_worm_of_the_swamp_2020_thumb.jpg'),
        width: 600,
        height: 430,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on cold pressed watercolour paper. 210 x 297 mm ( 8.27 x 11.69 in), 2020.',
    price: 92,
    original: 'SOLD',
    prints: 'NOTYET',
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/799874088/',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "Sometimes I don't feel like using reference images. This painting was born on such an occasion, I just started drawing straight on the blank paper, and the result was this little illustration.<br /><br />I imagined a scene as if I was illustrating a fairy tale, where this ancient beast suddenly emerges from the dark water, looking like she has been sleeping down there for hundreds of years. Despite she scared the rider, she meant no harm, on the contrary, she was excited to have a visitor at last!",
  },
  the_climbing_rose_gate: {
    title: 'The Climbing Rose Gate',
    imgs: {
      full: {
        src: require('./the_climbing_rose_gate_2020_web.jpg'),
        width: 709,
        height: 1000,
      },
      thumb: {
        src: require('./the_climbing_rose_gate_2020_thumb.jpg'),
        width: 425,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on cold pressed watercolour paper. 210 x 297 mm ( 8.27 x 11.69 in), 2020.',
    price: 82,
    original: 'SOLD',
    prints: 'NOTYET',
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/813763953/',
    printUrl: 'https://www.etsy.com/ie/listing/805097264/',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "When I work on a larger painting that takes more time to finish I have to take a break from it time to time, and come back with fresh eyes. Usually in these intervals I like to doodle things that don't require reference or research, just a blank paper and me. This is how this unicorn started, but it grew so close to my heart by the end that I made her into a finished painting.<br /><br />Maybe that need for a break gave this painting its romantic atmosphere. My favourite flower is the rose, and I wanted to create something really pleasant for me to look at. Like a true dream world. There is a little girl still in me, who likes rainbows and unicorns, and sometimes all she needs is a good old-fashioned fairy tale. She definitely got that when I was painting this artwork.",
  },
  the_summoning: {
    title: 'The Summoning',
    imgs: {
      full: {
        src: require('./the_summoning_2020_web.jpg'),
        width: 703,
        height: 1000,
      },
      thumb: {
        src: require('./the_summoning_2020_thumb.jpg'),
        width: 422,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on cold pressed watercolour paper. 420 x 594 mm (16.53 x 23.39 in), 2020.',
    price: 250,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/799936804/',
    printUrl: 'https://www.etsy.com/ie/listing/804184536/',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'Considering the preparations, this painting took me the longest ever to finish. When I had the idea of the subject, I knew I had to go to Phoenix Park to take reference photos of the deer there. But even when I started planning the painting I had no idea about the composition... it all came to life on the paper eventually, no matter how many sketches I made to plan it.<br /><br />I wanted to create a dream-like scene, where some of the details might get lost. So I added a greenish grey wash to create a foggy background. Some quirky elements were also sneaked into the picture, like the eyeball staff of the deer spirit. I really enjoyed drawing such weird things, so I might explore this path a bit more in the future.<br /><br />This is the first painting in a long while where I really ignored outside opinions. To most people the subject is not common and too weird. But this time I let my creativity roam free and just drew and paint whatever occurred to me, not being concerned with feedback. Therefore I would recommend it only to those people who are open to curiosity, who like to meet things they don\'t understand. If you want your guests ask "oh, what is this artwork about?". And you\'re absolutely free to answer whatever you think it is about!',
  },
  the_sunbender: {
    title: 'The Sunbender',
    imgs: {
      full: {
        src: require('./the_sunbender_2020_web.jpg'),
        width: 694,
        height: 1000,
      },
      thumb: {
        src: require('./the_sunbender_2020_thumb.jpg'),
        width: 416,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink, watercolour and coloured pencil on mixed media paper. 297 x 420 mm (11.69 x 16.53 in), 2020.',
    price: 120,
    original: 'SOLD',
    prints: 'AVAILABLE',
    buyUrl: '',
    printUrl: 'https://www.etsy.com/ie/listing/819485839/',
    discount: 0,
    discountPrint: 0,
    type: 'mixed_media_painting',
    story:
      'I was on a trip to the UK when the idea of this image came to me. I couldn\'t work on any kind of art while I was away, but I have a deal I made with myself: every day I have to make art in some form, even for just 5 minutes. So I carry my sketchbook around everywhere, and whenever I can\'t be in the studio, I\'m sketching.<br /><br />As usual when I opened the sketchbook to draw I didn\'t really have anything in mind. It was a chore. A promise I have to fulfil even though I don\'t feel like it. And then I looked out the window to see the beautiful springtime Manchester weather as the rain was lashing against the glass. I needed something bright and sparkling.<br /><br />So I imagined a dragon soaring on the sky, but on a colourful sky, the ones you can see after storms and in Disney movies. And I wanted to see a dragon shining through all the remaining darkness. That is how this painting was sketched out. I had everything in mind, and once I got home I started painting.<br /><br />I used a <a href="https://unsplash.com/photos/28ZbKOWiZfs" title="The Sunbender background reference photo" target="_blank" rel="noopener noreferrer" >reference photo</a> for the sky, which I wanted to look carefree with pink clouds.',
  },
  the_dragon_and_the_kirin: {
    title: 'The Dragon and The Kirin',
    imgs: {
      full: {
        src: require('./the_dragon_and_the_kirin_2020_web.jpg'),
        width: 1000,
        height: 696,
      },
      thumb: {
        src: require('./the_dragon_and_the_kirin_2020_thumb.jpg'),
        width: 600,
        height: 418,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on cold pressed watercolour paper. 297 x 420 mm (16.53 x 11.69 in), 2020.',
    price: 112,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/809272187/',
    printUrl: 'https://www.etsy.com/ie/listing/805159500/',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "I played around with a Chinese style dragon concept so much I ended up painting a fighting scene. I wanted to show the dynamic movement and energy of a moment before collision.<br /><br />The story I imagined behind the scene is something like David and Goliath. The confidence of superiority is reflected on the dragon's face, while the little kirin is facing the beast with unseen bravery.<br /><br />I didn't have a clear idea first how I was going to stage this. When I think of a really dynamic scene like this fighting one, I usually have only a feeling in my head, not the actual concept. I want to show strength! I want to show power! I want the viewer to think \"man, this is epic!\" These are my guidelines when I start figuring out where that leg should stand, how that arm should bend, and the wiggle of the tail.<br /><br />This is a perfect picture for any anime or fantasy fan, who doesn't want to see pretty flowers on their walls. This painting is for people who like action and adventure.",
  },
  morozovas_stag: {
    title: "Morozova's Stag",
    imgs: {
      full: {
        src: require('./morozovas_stag_2020_web.jpg'),
        width: 711,
        height: 1000,
      },
      thumb: {
        src: require('./morozovas_stag_2020_thumb.jpg'),
        width: 427,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on cold pressed watercolour paper. 420 x 297 mm ( 11.69 x 16.53 in), 2020.',
    price: 126,
    original: 'SOLD',
    prints: 'NOTYET',
    buyUrl: 'https://www.etsy.com/ie/listing/795402030/',
    printUrl: 'https://www.etsy.com/ie/listing/818583103/',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "Art inspired by Leigh Bardugo's <i>Shadow and bone</i>. Morozova's stag was a white magical stag, who was incredibly difficult to track down. When the heroes eventually encountered him, he turned up on a snowy field at night. The little light there was made him look like he was shining in the darkness. I liked the scene so much I wanted to paint it how I saw the scene in my head.",
  },
};

export default imgData_2020;
